import {
  Box,
  Container,
  Grid,
  Typography,
  Tabs,
  Tab,
  Button,
  Link,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomerLeadList from "./CustomerLeadList";
import PageInfoTitle from "../../../components/pageTitle/PageInfoTitle";
import CustomerLeadDetails from "./CustomerLeadDetails";
import { useDispatch, useSelector } from "react-redux";
import {
  getCustomerConfirmDetailsAction,
  getCustomerLeadDetailsAction,
  getCustomerLeadsAction,
  getCustomerQuoteDetailsAction,
  getCustomerSurveyDetailsAction,
  requestStartSurveyAction,
  requestSurveyAction,
  setRequestStartSurveyAction,
  setUpdateCustomerQuote,
  setUpdateQuatationAction,
} from "../../../store/reducers/customerSlice";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";
import AlertPopup from "../../../components/common/alertPopup/AlertPopup";
import Notification from "../../../components/common/notification/Notification";
import LeadSurveyForm from "../../../clientAdmin/components/lead/survey/LeadSurveyForm";
import useStyles from "../../../clientAdmin/components/lead/survey/leadSurveyStyle";
import { getSingleLeadAction } from "../../../store/reducers/leadSlice";
import {
  getAllLinkedItemsAction,
  getAllRoomListAction,
} from "../../../store/reducers/leadSurveySlice";
import CustomQuoteConfirm from "./CustomQuoteConfirm";

const NewConfirmation = () => {
  const dispatch = useDispatch();
  const {
    customerLeadDetails,
    customerLeads,
    isQuatationResponse,
    isCustomerQuoteUpdated,
    isRequestSurveyStart,
  } = useSelector((state: any) => state.customer);
  const { surveyRoomList, linkedItems } = useSelector(
    (state: any) => state.leadSurvey,
  );

  const { leadDetails } = useSelector((state: any) => state.lead);
  const [show, setShow] = useState(false);
  const [type, setType] = useState("");
  const [generateId, setGenerateId] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState(0);
  const [showSurveyAlert, setShowSurveyAlert] = useState(false);
  const [alertType, setAlertType] = useState(null);
  const classes = useStyles({ show });

  // Step 1: Call getCustomerLeadsAction when component mounts
  useEffect(() => {
    dispatch(getCustomerLeadsAction());
  }, []);

  useEffect(() => {
    if (!surveyRoomList) {
      dispatch(
        getAllRoomListAction({
          leadID: leadDetails?.lead?.generated_id,
          role: "customer",
        }),
      );
    }
    if (!linkedItems) {
      dispatch(getAllLinkedItemsAction());
    }
  }, [leadDetails?.lead?.generated_id]);

  // Step 2: After customerLeads response, set generateId from first lead
  useEffect(() => {
   
    if (customerLeads && customerLeads.length > 0 && !generateId) {
      const firstLeadId =
        customerLeads[0]?.generateId || customerLeads[0]?.generated_id;
      setGenerateId(firstLeadId);
    }
  }, [customerLeads, generateId]);

  // Step 3: After generateId is set, call getCustomerLeadDetailsAction
  useEffect(() => {
    if (generateId) {
      dispatch(
        getCustomerLeadDetailsAction({
          leadId: generateId,
          query: "get-lead",
        }),
      );
    }
  }, [generateId]);

  useEffect(() => {
    if (isRequestSurveyStart) {
      setShow(true);
      setType("survey");
      dispatch(setRequestStartSurveyAction(false));
    }
  }, [isRequestSurveyStart]);

  // Step 4: After customerLeadDetails response, call appropriate API based on activeTab
  useEffect(() => {
    if (generateId && customerLeadDetails) {
      if (activeTab === 0 && customerLeadDetails?.lead?.survey_id) {
        // Survey Tab - call getSurveyDetails with survey_id
        dispatch(
          getCustomerSurveyDetailsAction({
            surveyID: customerLeadDetails?.lead?.survey_id,
            query: "get-survey",
          }),
        );
      } 
      
      dispatch(setUpdateQuatationAction(false));
      dispatch(setUpdateCustomerQuote(false));
    }
  }, [
    activeTab,
    generateId,
    customerLeadDetails,
    isQuatationResponse,
    isCustomerQuoteUpdated,
  ]);

  useEffect(() => {
    if (generateId) {
      dispatch(getSingleLeadAction({ generateId, role: "customer" }));
    }
  }, [generateId]);

  useEffect(() => {
    return () => {
      dispatch(setNotificationAction({ message: [], severity: "error" }));
    };
  }, []);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const handleRequestSurvey = (type: any) => {
    setShowSurveyAlert(true);
    setAlertType(type);
  };

  const handleConfirmRequestSurvey = () => {
    if (generateId) {
      if (alertType === "request") {
        dispatch(requestSurveyAction({ leadId: generateId }));
        setShowSurveyAlert(false);
      } else if (alertType === "start") {
        dispatch(requestStartSurveyAction({ leadId: generateId }));
        setShowSurveyAlert(false);
      }
    }
  };

  const handleCloseAlert = () => {
    setShowSurveyAlert(false);
  };

  return (
    <>
      <Notification />
      <Grid
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 1, md: 1 }}
        sx={{ background: "#f4f4f4" }}
      >
        <Grid item xs={12} md={2.5}>
          {/* <Container
                    maxWidth="md"
                    sx={{ bgcolor: "#fff", padding: "10px 2px !important" }}
                  > */}
          <Box
            sx={{
              // bgcolor: "#fff",
              height: { xs: "auto", md: "100vh" },
              // minHeight:'100vh'
              // border: "1px solid #d1cfcf",
              // borderRadius: "5px",
              // padding: "4px",
            }}
          >
            <CustomerLeadList setGenerateId={setGenerateId} />
          </Box>
        </Grid>
        <Grid item xs={12} md={9.5}>
          <Container
            maxWidth="lg"
            sx={{
              paddingLeft: "0px !important",
              paddingRight: "0px !important",
            }}
          >
            <Box
              sx={{
                height: { xs: "auto", md: "100vh" },
                // border: "1px solid #d1cfcf",
                // borderRadius: "5px",
                paddingLeft: "0px !important",
                paddingRight: "0px !important",
                // padding: "0px 16px",
                overflow: "scroll",
              }}
            >
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  bgcolor: "#fff",
                  zIndex: 1,
                  marginTop: "6px",
                  border: "1px solid #C4CDD5",
                }}
              >
                <Tabs
                  value={activeTab}
                  onChange={handleTabChange}
                  textColor="secondary"
                  indicatorColor="secondary"
                  aria-label="secondary tabs example"
                  sx={{
                    borderRight: 1,
                    // marginRight: "10px",
                    borderColor: "divider",
                    minWidth: "250px",
                    backgroundColor: "#fafafa",
                    "& .MuiTab-root": {
                      alignItems: "flex-start",
                      justifyContent: "flex-start",
                      textTransform: "none",
                      fontSize: "15px",
                      fontWeight: 600,
                      color: "#333",
                    },
                    "& .Mui-selected": {
                      color: "#1d997d",
                      backgroundColor: "#d4f9dc",
                    },
                  }}
                >
                  <Tab label="Survey" sx={{ minWidth: "none", flex: 1 }} />
                  {/* <Tab label="Quotes" sx={{ minWidth: "none", flex: 1 }} />
                  <Tab label="Confirm" sx={{ minWidth: "none", flex: 1 }} /> */}
                  <Tab label="Quote/Confirm" sx={{ minWidth: "none", flex: 1 }} />
                </Tabs>
              </Box>
              <Box
                sx={{
                  bgcolor: "#fff",
                  height: { xs: "auto" },
                  border: "1px solid #d1cfcf",
                  borderRadius: "5px",
                  marginTop: "10px",
                  padding: "20px !important",
                }}
              >
                {activeTab === 0 && (
                  <Box>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: "14px",
                        color: "#333",
                        marginBottom: "16px",
                        lineHeight: 1.6,
                      }}
                    >
                      We have not yet carried out a survey or given you a quote
                      for your removal.
                    </Typography>

                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: "14px",
                        color: "#333",
                        marginBottom: "16px",
                        lineHeight: 1.6,
                      }}
                    >
                      We would recommend getting one of our professional
                      Surveyors to carry out your survey. If you would like this
                      then click the button and we will be in touch to organise
                      it for you
                    </Typography>

                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: "14px",
                        color: "#333",
                        marginBottom: "20px",
                        lineHeight: 1.6,
                      }}
                    >
                      If you prefer you can carry out your own survey using the
                      online form. Instructions on how to do this can be found{" "}
                      <Link
                        href="#"
                        sx={{
                          color: "#333",
                          fontWeight: 700,
                          textDecoration: "underline",
                        }}
                      >
                        HERE
                      </Link>
                    </Typography>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "12px",
                      }}
                    >
                      {(customerLeadDetails?.lead?.survey_status ===
                        "PENDING" ||
                        customerLeadDetails?.lead?.survey_status === null) && (
                        <>
                          <Button
                            variant="outlined"
                            sx={{
                              color: "#333",
                              fontSize: "14px",
                              fontWeight: 600,
                              textTransform: "none",
                              padding: "8px 16px",
                            }}
                            disabled={
                              customerLeadDetails?.lead?.is_survey_requested
                                ? true
                                : false
                            }
                            onClick={() => handleRequestSurvey("request")}
                          >
                            Request a survey
                          </Button>

                          <Button
                            variant="outlined"
                            sx={{
                              color: "#333",
                              fontSize: "14px",
                              fontWeight: 600,
                              textTransform: "none",
                              padding: "8px 16px",
                            }}
                            onClick={() => handleRequestSurvey("start")}
                            // onClick={() => {
                            //   setShow(true);
                            //   setType("survey");
                            // }}
                          >
                            Carry out your own survey
                          </Button>
                        </>
                      )}
                      {customerLeadDetails?.lead?.survey_id &&
                        customerLeadDetails?.lead?.survey_status !==
                          "PENDING" &&
                        customerLeadDetails?.lead?.survey_status !== null && (
                          <Button
                            variant="outlined"
                            sx={{
                              color: "#333",
                              fontSize: "14px",
                              fontWeight: 600,
                              textTransform: "none",
                              padding: "8px 16px",
                            }}
                            onClick={() => {
                              setShow(true);
                              setType("survey");
                            }}
                          >
                            View Survey Details
                          </Button>
                        )}
                    </Box>
                  </Box>
                )}
                {/* {activeTab === 1 && (
                  <Box>
                    <CustomerQuoteView
                      leadDetails={customerLeadDetails?.lead}
                    />
                  </Box>
                )}
                {activeTab === 2 && (
                  <Box>
                    <ConfirmationQuote />
                  </Box>
                )} */}
                {activeTab === 1 && (
                  <Box>
                    <CustomQuoteConfirm leadDetails={customerLeadDetails?.lead} />
                  </Box>
                )}
              </Box>
            </Box>
          </Container>
        </Grid>
      </Grid>
      {show && type === "survey" && (
        <section className={show ? classes.surveyPopupOverlay : ""}>
          <LeadSurveyForm show={show} setShow={setShow} />
        </section>
      )}
      {/* Alert Modal for Request Survey */}
      {showSurveyAlert && (
        <AlertPopup
          open={showSurveyAlert}
          title={alertType === "request" ? "Request Survey" : "Alert"}
          content={
            alertType === "request"
              ? "Are you sure you want to request a professional survey? We will contact you shortly to schedule it."
              : "Are you sure you want to start the own survey?"
          }
          onHide={handleCloseAlert}
          submitHandler={handleConfirmRequestSurvey}
          yesText="Yes"
          noText="Cancel"
        />
      )}
    </>
  );
};
export default NewConfirmation;
